import { assert } from '@Utils/assert';
import { fromJS } from 'immutable';

import { normalizeItems, findByIdFromIdsCollectionFn } from '@Utils';

export function setChildrenRetrievalStatusAsFeched(group) {
  assert(group.get('childrenRetrievalStatus') === 'fetching', 'Previous status has to be "fetching", something went wrong');

  return group.set('childrenRetrievalStatus', 'fetched');
}

export function mergeItems(items) {
  return function merge(oldItems) {
    return oldItems.merge(fromJS(items));
  };
}

export function insertIds(ids, rootGroupId) {
  return function insert(oldIds) {
    const rootGroupIdIndex = oldIds.findIndex(findByIdFromIdsCollectionFn(rootGroupId));
    const filrstPart = oldIds.slice(0, rootGroupIdIndex + 1);
    const secondPart = oldIds.slice(rootGroupIdIndex + 1);

    return filrstPart.concat(fromJS(ids)).concat(secondPart);
  };
}

export default function updateThesaurusHandler(state, action) {
  const { key, filterId, children, rootGroupId } = action.payload;
  const resultPath = [key, 'items', filterId, 'thesaurusGroups'];
  const { items, ids } = normalizeItems(children);

  return state
    .updateIn([...resultPath, 'items', rootGroupId], setChildrenRetrievalStatusAsFeched)
    .updateIn([...resultPath, 'items'], mergeItems(items))
    .updateIn([...resultPath, 'ids'], insertIds(ids));
}
